// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alpaca-config-container {
  padding: 2rem;
  max-width: 900px;
  margin: 0 auto;
}

.alpaca-config-header {
  margin-bottom: 2rem;
}

.alpaca-config-header h1 {
  font-size: 2rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
}

.alpaca-config-header p {
  color: #666;
  font-size: 1rem;
}

.alert {
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.alert-error {
  background-color: #fee;
  border: 1px solid #fcc;
  color: #c33;
}

.alert-success {
  background-color: #efe;
  border: 1px solid #cfc;
  color: #3c3;
}

.alert-icon {
  font-size: 1.25rem;
}

.alert-message {
  flex: 1 1;
}

.alpaca-config-card {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  font-weight: 500;
  color: #333;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.2s;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
}

.form-help {
  display: block;
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #666;
}

.form-actions {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #eee;
}

.btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background-color: #4a90e2;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background-color: #357abd;
}

.btn-danger {
  background-color: #e74c3c;
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background-color: #c0392b;
}

.config-info {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #eee;
}

.config-info h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.info-label {
  font-size: 0.85rem;
  color: #666;
  font-weight: 500;
}

.info-value {
  font-size: 1rem;
  color: #333;
}

.status-active {
  color: #27ae60;
  font-weight: 500;
}

.status-inactive {
  color: #e74c3c;
  font-weight: 500;
}

.alpaca-config-help {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  margin-top: 2rem;
}

.alpaca-config-help h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
}

.alpaca-config-help ol {
  margin-left: 1.5rem;
  margin-bottom: 1rem;
  color: #555;
  line-height: 1.8;
}

.alpaca-config-help ol li {
  margin-bottom: 0.5rem;
}

.alpaca-config-help a {
  color: #4a90e2;
  text-decoration: none;
}

.alpaca-config-help a:hover {
  text-decoration: underline;
}

.alpaca-config-help .warning {
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 6px;
  padding: 1rem;
  margin-top: 1rem;
  color: #856404;
}

.alpaca-config-help .warning strong {
  font-weight: 600;
}

.form-section-divider {
  margin: 2rem 0 1.5rem 0;
  padding-top: 2rem;
  border-top: 2px solid #eee;
}

.form-section-divider h3 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
}

.form-section-divider p {
  font-size: 0.9rem;
  color: #666;
  margin: 0;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem;
  gap: 1rem;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4a90e2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Styles pour la liste des sous-comptes */
.sub-accounts-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.sub-account-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1.5rem;
  background: #fafafa;
  transition: all 0.2s;
}

.sub-account-item:hover {
  border-color: #4a90e2;
  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.1);
}

.sub-account-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.sub-account-header h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 0.5rem 0;
}

.sub-account-actions {
  display: flex;
  gap: 0.5rem;
}

.account-type-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 500;
}

.account-type-badge.live {
  background-color: #fee;
  color: #c33;
  border: 1px solid #fcc;
}

.account-type-badge.paper {
  background-color: #eef;
  color: #33c;
  border: 1px solid #ccf;
}

.sub-account-details {
  margin-top: 1rem;
}

.limits-info {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #eee;
  text-align: center;
  color: #666;
  font-size: 0.9rem;
}

.btn-sm {
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover:not(:disabled) {
  background-color: #5a6268;
}

`, "",{"version":3,"sources":["webpack://./src/pages/AlpacaConfig.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".alpaca-config-container {\n  padding: 2rem;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.alpaca-config-header {\n  margin-bottom: 2rem;\n}\n\n.alpaca-config-header h1 {\n  font-size: 2rem;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin-bottom: 0.5rem;\n}\n\n.alpaca-config-header p {\n  color: #666;\n  font-size: 1rem;\n}\n\n.alert {\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.alert-error {\n  background-color: #fee;\n  border: 1px solid #fcc;\n  color: #c33;\n}\n\n.alert-success {\n  background-color: #efe;\n  border: 1px solid #cfc;\n  color: #3c3;\n}\n\n.alert-icon {\n  font-size: 1.25rem;\n}\n\n.alert-message {\n  flex: 1;\n}\n\n.alpaca-config-card {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 2rem;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 0.5rem;\n  font-size: 0.95rem;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 1rem;\n  transition: border-color 0.2s;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #4a90e2;\n  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);\n}\n\n.form-help {\n  display: block;\n  margin-top: 0.5rem;\n  font-size: 0.85rem;\n  color: #666;\n}\n\n.form-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #eee;\n}\n\n.btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background-color: #4a90e2;\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: #357abd;\n}\n\n.btn-danger {\n  background-color: #e74c3c;\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background-color: #c0392b;\n}\n\n.config-info {\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid #eee;\n}\n\n.config-info h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 1rem;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.info-label {\n  font-size: 0.85rem;\n  color: #666;\n  font-weight: 500;\n}\n\n.info-value {\n  font-size: 1rem;\n  color: #333;\n}\n\n.status-active {\n  color: #27ae60;\n  font-weight: 500;\n}\n\n.status-inactive {\n  color: #e74c3c;\n  font-weight: 500;\n}\n\n.alpaca-config-help {\n  background: #f8f9fa;\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-top: 2rem;\n}\n\n.alpaca-config-help h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 1rem;\n}\n\n.alpaca-config-help ol {\n  margin-left: 1.5rem;\n  margin-bottom: 1rem;\n  color: #555;\n  line-height: 1.8;\n}\n\n.alpaca-config-help ol li {\n  margin-bottom: 0.5rem;\n}\n\n.alpaca-config-help a {\n  color: #4a90e2;\n  text-decoration: none;\n}\n\n.alpaca-config-help a:hover {\n  text-decoration: underline;\n}\n\n.alpaca-config-help .warning {\n  background: #fff3cd;\n  border: 1px solid #ffc107;\n  border-radius: 6px;\n  padding: 1rem;\n  margin-top: 1rem;\n  color: #856404;\n}\n\n.alpaca-config-help .warning strong {\n  font-weight: 600;\n}\n\n.form-section-divider {\n  margin: 2rem 0 1.5rem 0;\n  padding-top: 2rem;\n  border-top: 2px solid #eee;\n}\n\n.form-section-divider h3 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 0.5rem;\n}\n\n.form-section-divider p {\n  font-size: 0.9rem;\n  color: #666;\n  margin: 0;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem;\n  gap: 1rem;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #4a90e2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Styles pour la liste des sous-comptes */\n.sub-accounts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.sub-account-item {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 1.5rem;\n  background: #fafafa;\n  transition: all 0.2s;\n}\n\n.sub-account-item:hover {\n  border-color: #4a90e2;\n  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.1);\n}\n\n.sub-account-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.sub-account-header h3 {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 0.5rem 0;\n}\n\n.sub-account-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.account-type-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.account-type-badge.live {\n  background-color: #fee;\n  color: #c33;\n  border: 1px solid #fcc;\n}\n\n.account-type-badge.paper {\n  background-color: #eef;\n  color: #33c;\n  border: 1px solid #ccf;\n}\n\n.sub-account-details {\n  margin-top: 1rem;\n}\n\n.limits-info {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #eee;\n  text-align: center;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.btn-sm {\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n}\n\n.btn-secondary {\n  background-color: #6c757d;\n  color: white;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: #5a6268;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
